/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { MatDialog, MatDialogState } from "@angular/material/dialog";
import { User } from "src/app/features/liveshop/models/user.interface";
import { InventoryService } from "../inventory/inventory-service";
import { addProductsComponent } from "src/app/features/liveshop/sidepanel/cart/addProducts/addProducts.component";
import { SlotService } from "../slot/slot.service";
import { UpdateAppointmentProductsService } from "../inventory/update-appointment-products-service";
import { BehaviorSubject } from "rxjs";
import { UserService } from "valuchaincommon/common-services/user/user.service";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MediaStreamPermissionsComponent } from "src/app/features/liveshop/media-stream-permissions/media-stream-permissions.component";

@Injectable({
  providedIn: "root",
})
export class LiveshopService {
  currentOrnamentType = "earrings";
  disabledVideoCamButton = false;
  constructor(
    public dialog: MatDialog,
    private inventoryService: InventoryService,
    public slotService: SlotService,
    private updateAppointmentProductsService: UpdateAppointmentProductsService,
    public bottomSheet: MatBottomSheet,
    public valuChainUserService: UserService
  ) {}
  socket;
  code;
  sharedUser;
  isScreenPinned = false;
  splitScreenPinnedUser: User;
  splitScreenPinnedUserSubscribe = new BehaviorSubject(false);
  isOrderSummaryOpen = new BehaviorSubject("");
  shareLink = new BehaviorSubject(false);
  shareLinkOb = this.shareLink.asObservable();
  openCart = new BehaviorSubject(false);
  openCartOb = this.openCart.asObservable();
  onPreviewClick = new BehaviorSubject(undefined);
  onPreviewClickOb = this.onPreviewClick.asObservable();
  onReturnToLandingPage = new BehaviorSubject(undefined);
  onReturnToLandingPageOb = this.onReturnToLandingPage.asObservable();
  onMenuActions = new BehaviorSubject(undefined);
  onMenuActionsOb = this.onMenuActions.asObservable();
  isTryonOpen = false;
  sharingScreen = false;
  isPresentingBoard = false;
  videoPaused = true;
  audioPaused = true;
  videoPermissionsAllowed = true;
  audioPermissionsAllowed = true;
  mediaStreamPermissionsComponentRef;
  cart = [];
  response_cart = [];
  aggregated = {};
  cartLength = 0;
  conf: Boolean = false;
  products = [];
  viewProducts = [];
  selectedProduct = null;
  groups;
  appointmentDetails;
  users: User[] = [];
  tryOnWidth = 0;
  tryOnHeight = 0;
  currentUser;
  displayPIPInDesktop = false;
  displayPIPInMobile = false;
  isBoardOpened = false;
  isCustomerPresent = false;
  isSalesPerson = false;
  orderLinkData;
  isCheckoutDone: boolean = false;
  isGridView = true;
  isGridViewDesk = true;
  isBrowserCart = false;

  isMobileDevice() {
    return window.innerWidth <= 600;
  }

  additemtoCart(spot, isSpotB2B, isQuantityEnabled, selfUser) {
    var productData;
    var item;
    if (typeof this.selectedProduct !== "object") {
      productData = JSON.parse(JSON.stringify(this.selectedProduct));
      item = JSON.parse(JSON.stringify(this.selectedProduct));
    } else {
      productData = this.selectedProduct;
      item = this.selectedProduct;
    }
    const groupId = item._id;
    const key = "Size";
    if (this.conf) {
      this.inventoryService
        .inventoriesByInventoryGroup(groupId, key)
        .subscribe((res) => {
          const data = res;
          if (data && data.length) {
            let dialogRef = this.bottomSheet.open(addProductsComponent, {
              data: {
                inventoryItems: data,
                isPriceDisplay: this.appointmentDetails.companyConfig
                  .isPriceDisplay,
              },
              // disableClose: true,
            });
            dialogRef.instance.onAdd.subscribe((prod) => {
              const index = prod.findIndex(
                (product) => product.numberOfUnits !== 0
              );
              if (index !== -1) {
                const products = prod.filter(
                  (product) => product.numberOfUnits !== 0
                );
                let units = 0;
                products.map((each) => (units += each.numberOfUnits));
                const email = spot && selfUser.email;
                this.slotService
                  .updateAppointmentProducts(
                    this.code,
                    {
                      inventoryGroupSet: productData.inventoryCollection
                        ? productData.inventoryCollection.inventoryGroupSet
                        : undefined,
                      inventoryGroup: productData._id,
                      inventories: products,
                      numberOfUnits: units,
                    },
                    "products",
                    localStorage.getItem("retailerToken") ? undefined : email,
                    isSpotB2B
                  )
                  .subscribe((res) => {
                    this.updateAppointmentProductsService.cartRes.next(res);
                    this.response_cart = res.map((item) => {
                      this.aggregated[item.inventoryGroup._id] =
                        item.inventories;
                      if (this.socket) {
                        this.socket.emit("addItemtoCart", {
                          cart: this.aggregated,
                          conf: this.conf,
                          type: "add",
                        });
                        this.socket.emit("addToCart", {
                          productID: item.inventoryGroup._id,
                          numberOfUnits: isQuantityEnabled
                            ? productData.numberOfUnits
                            : undefined,
                          classifications: item.classifications,
                        });
                      }
                    });
                  });
              }
              dialogRef.dismiss();
            });
          } else {
            if (this.socket) {
              this.socket.emit("addToCart", {
                productID: productData._id,
                numberOfUnits: isQuantityEnabled
                  ? productData.numberOfUnits
                  : undefined,
                classifications: productData.classifications,
              });
            }
          }
        });
    } else {
      const product = {
        inventoryGroup: this.selectedProduct._id,
        classification: this.selectedProduct.classification
          ? this.selectedProduct.classification
          : undefined,
        numberOfUnits: this.selectedProduct.numberOfUnits
          ? this.selectedProduct.numberOfUnits
          : this.appointmentDetails.owner.businessUnit.settings.whiteshop
              .isInventoryGroupQuantity
          ? 1
          : undefined,
        inventoryGroupSet:
          this.selectedProduct.inventoryCollection &&
          this.selectedProduct.inventoryCollection.inventoryGroupSet
            ? this.selectedProduct.inventoryCollection.inventoryGroupSet
            : undefined,
        removeClassification: this.selectedProduct.removeClassification
          ? this.selectedProduct.removeClassification
          : undefined,
        // unitPrice : this.selectedProduct.unitPrice
      };
      const email = spot && selfUser.email;
      this.slotService
        .updateAppointmentProducts(
          this.code,
          product,
          item.isUpdate ? "updateProduct" : "products",
          email,
          isSpotB2B
        )
        .subscribe((res) => {
          this.updateAppointmentProductsService.cartRes.next(res);
          this.mapToCart(res);
          if (this.socket) {
            this.socket.emit("addItemtoCart", {
              cart: this.response_cart,
              conf: this.conf,
              type: "add",
            });
          }
        });
      if (this.socket) {
        this.socket.emit("addToCart", {
          productID: this.selectedProduct._id,
          numberOfUnits: isQuantityEnabled
            ? this.selectedProduct.numberOfUnits
            : undefined,
          classifications: this.selectedProduct.classifications
            ? this.selectedProduct.classifications
            : [],
        });
      }
    }
  }

  onDeleteClicked(data, spot, isSpotB2B, isQuantityEnabled, selfUser) {
    if (data) {
      const initialData = data;
      const item = this.selectedProduct;
      const groupId = data.inventoryGroup;
      const key = "Size";
      const aggregatedItem = this.aggregated[groupId];
      if (this.conf) {
        this.inventoryService
          .inventoriesByInventoryGroup(groupId, key)
          .subscribe((res) => {
            const data = res;
            if (data && data.length) {
              let dialogRef = this.bottomSheet.open(addProductsComponent, {
                data: {
                  inventoryItems: data,
                  isPriceDisplay: this.appointmentDetails.companyConfig
                    .isPriceDisplay,
                  aggregated: aggregatedItem,
                },
                // disableClose: true,
              });
              dialogRef.instance.onAdd.subscribe((prod) => {
                let flag = false;
                if (prod) {
                  prod.forEach((product) => {
                    if (product.numberOfUnits !== 0) {
                      flag = true;
                    }
                  });
                }
                if (flag) {
                  const products = prod.filter(
                    (product) => product.numberOfUnits !== 0
                  );
                  let units = 0;
                  products.map((each) => (units += each.numberOfUnits));
                  const email = spot && selfUser.email;
                  this.updateAppointmentProductsService
                    .updateAppointmentProducts(
                      this.code,
                      {
                        inventoryGroup: groupId,
                        inventories: products,
                        numberOfUnits: units,
                      },
                      "updateProduct",
                      localStorage.getItem("retailerToken") ? undefined : email,
                      isSpotB2B
                    )
                    .subscribe((res) => {
                      this.updateAppointmentProductsService.cartRes.next(res);
                      this.response_cart = res.map((item) => {
                        this.aggregated[item.inventoryGroup._id] =
                          item.inventories;
                        if (this.socket) {
                          this.socket.emit("addItemtoCart", {
                            cart: this.aggregated,
                            conf: this.conf,
                            type: "add",
                          });
                          this.socket.emit("addToCart", {
                            productID: item.inventoryGroup._id,
                            numberOfUnits: isQuantityEnabled
                              ? this.selectedProduct.numberOfUnits
                              : undefined,
                          });
                        }
                      });
                    });
                } else {
                  const email = spot && selfUser.email;
                  this.updateAppointmentProductsService
                    .updateAppointmentProducts(
                      this.code,
                      initialData,
                      "deleteProduct",
                      localStorage.getItem("retailerToken") ? undefined : email,
                      isSpotB2B
                    )
                    .subscribe((res) => {
                      if (this.conf) {
                        this.mapToAggregated(res);
                        this.updateAppointmentProductsService.cartRes.next(res);
                        if (this.socket) {
                          this.socket.emit("addItemtoCart", {
                            cart: this.aggregated,
                            conf: this.conf,
                            type: "delete",
                          });
                        }
                      } else {
                        this.updateAppointmentProductsService.cartRes.next(res);
                        this.mapToCart(res);
                        if (this.socket) {
                          this.socket.emit("addItemtoCart", {
                            cart: this.response_cart,
                            conf: this.conf,
                            type: "delete",
                          });
                        }
                      }
                    });
                  if (this.socket) {
                    this.socket.emit("removeFromCart", {
                      productID: groupId,
                    });
                  }
                }
                dialogRef.dismiss();
              });
            } else {
              const email = spot && selfUser.email;
              this.updateAppointmentProductsService
                .updateAppointmentProducts(
                  this.code,
                  initialData,
                  "deleteProduct",
                  localStorage.getItem("retailerToken") ? undefined : email,
                  isSpotB2B
                )
                .subscribe((res) => {
                  if (this.conf) {
                    this.mapToAggregated(res);
                    this.updateAppointmentProductsService.cartRes.next(res);
                    if (this.socket) {
                      this.socket.emit("addItemtoCart", {
                        cart: this.aggregated,
                        conf: this.conf,
                        type: "delete",
                      });
                    }
                  } else {
                    this.updateAppointmentProductsService.cartRes.next(res);
                    this.mapToCart(res);
                    if (this.socket) {
                      this.socket.emit("addItemtoCart", {
                        cart: this.response_cart,
                        conf: this.conf,
                        type: "delete",
                      });
                    }
                  }
                });
              if (this.socket) {
                this.socket.emit("removeFromCart", {
                  productID: groupId,
                });
              }
            }
          });
      } else {
        const email = spot && selfUser.email;
        this.updateAppointmentProductsService
          .updateAppointmentProducts(
            this.code,
            data,
            "deleteProduct",
            localStorage.getItem("retailerToken") ? undefined : email,
            isSpotB2B
          )
          .subscribe((res) => {
            if (this.conf) {
              this.mapToAggregated(res);
              this.updateAppointmentProductsService.cartRes.next(res);
              if (this.socket) {
                this.socket.emit("addItemtoCart", {
                  cart: this.aggregated,
                  conf: this.conf,
                  type: "delete",
                });
              }
            } else {
              this.updateAppointmentProductsService.cartRes.next(res);
              this.mapToCart(res);
              if (this.socket) {
                this.socket.emit("addItemtoCart", {
                  cart: this.response_cart,
                  conf: this.conf,
                  type: "delete",
                });
              }
            }
          });
        if (this.socket) {
          this.socket.emit("removeFromCart", {
            productID: groupId,
          });
        }
      }
    }
  }

  onEditClicked = (data, spot, isSpotB2B, selfUser) => {
    if (data) {
      const email = spot && selfUser.email;
      this.updateAppointmentProductsService
        .updateAppointmentProducts(
          this.code,
          data,
          "updateProduct",
          email,
          isSpotB2B
        )
        .subscribe((res) => {
          this.response_cart = res.map((item) => {
            this.mapToAggregated(res);
          });
          if (this.socket) {
            this.socket.emit("addItemtoCart", {
              cart: this.aggregated,
              conf: this.conf,
              type: "edit",
            });
          }
        });
    }
  };

  mapToCart(res) {
    this.response_cart = res.map((item) => {
      const sizeString = item.inventoryGroup.gradeDefinition.find(
        (i) => i && i.attributeKey === "Size"
      );
      var temp = [];
      if (sizeString) {
        temp = sizeString.attributeValue.split(",").map((size) => size.trim());
      }
      const sizes = Array.from(new Set(temp));
      return {
        image: item.inventoryGroup.gallery.images
          ? item.inventoryGroup.gallery.images[0].thumbnailImageURL
          : null,
        productBrandName: item.inventoryGroup.productBrandName,
        productCategoryName: item.inventoryGroup.productCategoryName,
        inventoryGroup: item.inventoryGroup._id,
        productBrandVarietyName: item.inventoryGroup.productBrandVarietyName,
        sizes,
        color:
          item.inventoryGroup.gradeDefinition &&
          item.inventoryGroup.gradeDefinition.find(
            (prod) => prod.attributeKey === "Colour"
          ) &&
          item.inventoryGroup.gradeDefinition.find(
            (prod) => prod.attributeKey === "Colour"
          ).attributeValue,
        material:
          item.inventoryGroup.gradeDefinition &&
          item.inventoryGroup.gradeDefinition.find(
            (prod) => prod.attributeKey === "Material"
          ) &&
          item.inventoryGroup.gradeDefinition.find(
            (prod) => prod.attributeKey === "Material"
          ).attributeValue,
        NRF:
          item.inventoryGroup.gradeDefinition &&
          item.inventoryGroup.gradeDefinition.find(
            (prod) => prod.attributeKey === "NRF"
          ) &&
          item.inventoryGroup.gradeDefinition.find(
            (prod) => prod.attributeKey === "NRF"
          ).attributeValue,
        classifications: item.classifications,
        numberOfUnits: item.numberOfUnits ? item.numberOfUnits : 0,
        gradeDefinition: item.inventoryGroup.gradeDefinition,
        price: item.inventoryGroup.price,
        inventoryGroupSet: item.inventoryGroupSet,
        name: item.inventoryGroup.name,
        productMainCategory: item.inventoryGroup.productMainCategory,
        inventoryGroupSets: item.inventoryGroup.inventoryGroupSets,
      };
    });
    console.log(this.response_cart);
    this.updateAppointmentProductsService.cartData.next(this.response_cart);
    for (var item of this.response_cart) {
      var colorProducts;
      if (this.products) {
        colorProducts = this.products.filter(
          (productItem) =>
            productItem.productBrandName === item.productBrandName &&
            productItem.productBrandVarietyName === item.productBrandVarietyName
        );
      }
      var color = [];
      var colorImages = [];
      if (colorProducts) {
        for (var prod of colorProducts) {
          var ans = prod.gradeDefinition.find(
            (colorprod) => colorprod.attributeKey === "Colour"
          );
          if (prod.imageUrl) {
            colorImages.push(prod.imageUrl.thumbnailImageURL);
          }
          if (ans) {
            color.push(ans.attributeValue);
          }
        }
      }
      item["colors"] = color;
      item["colorImages"] = colorImages;
    }
  }

  mapToAggregated(res) {
    this.aggregated = {};
    this.response_cart = res.map((item) => {
      this.aggregated[item.inventoryGroup._id] = item.inventories;
    });
  }
  getCartProducts(res) {
    console.log(
      res.filter(
        (each) =>
          each &&
          each.inventoryGroup &&
          !each.inventoryGroup.deleted &&
          !each.inventoryGroup.disabled &&
          !each.inventoryGroup.archive
      )
    );
    return res.filter(
      (each) =>
        each &&
        each.inventoryGroup &&
        !each.inventoryGroup.deleted &&
        !each.inventoryGroup.disabled &&
        !each.inventoryGroup.archive
    );
  }
  getProducts(data) {
    if (data.appointmentProducts && data.appointmentProducts.length) {
      return data.appointmentProducts.map((product) => ({
        ...product,
        selected: false,
        inCart: false,
        viewCount: product.usersViews ? product.usersViews.length : 0,
        _id: product.inventoryGroup
          ? product.inventoryGroup._id
          : product.inventoryGroupSet,
      }));
    }
  }
  assignAppointmentData(res) {
    this.slotService.rectangleSetting =
      res.appointment.owner.businessUnit.settings.whiteshop.isRectangleTemplate;
    const appointmentData = res;
    this.updateAppointmentProductsService.gradesList =
      res.appointment.owner.businessUnit.settings.whiteshop.gradeDefinition;

    this.code = appointmentData.appointment.code;
    this.slotService.appointmentCode = this.code;
    this.updateAppointmentProductsService.bussinessUnitSettings =
      appointmentData.appointment.owner.businessUnit.settings;
    this.appointmentDetails = appointmentData.appointment;
    this.updateAppointmentProductsService.isCartTypes = this.slotService.isCartTypes(
      appointmentData.appointment.owner.businessUnit
    );
    this.fetchCompleteBusinessUnit(res.appointment?.owner?.businessUnit);
    if (
      appointmentData.appointment.owner.businessUnit.settings &&
      appointmentData.appointment.owner.businessUnit.settings.appointment &&
      appointmentData.appointment.owner.businessUnit.settings.appointment
        .isInventoryGroupNumberOfUnits &&
      appointmentData.appointment.owner.businessUnit.settings.appointment
        .classifications
    ) {
      this.updateAppointmentProductsService.cartTypes =
        appointmentData.appointment.owner.businessUnit.settings.appointment.classifications;
    }

    this.updateAppointmentProductsService.cartRes.next(
      appointmentData.appointment.products
    );
    if (
      appointmentData.appointment &&
      appointmentData.appointment.appointmentProducts &&
      appointmentData.appointment.appointmentProducts.length
    ) {
      this.viewProducts = this.getProducts(appointmentData.appointment);
    }
    if (res && res.appointment && res.appointment.products) {
      this.updateAppointmentProductsService.cartRes.next(
        res.appointment.products
      );
      this.conf = res.appointment.companyConfig.isProductInventory;
      if (this.conf) {
        res.appointment.products
          .filter((each) => each.inventoryGroup)
          .map((item) => {
            this.slotService.setCartInventoryGroupData(item);
            this.aggregated[item.inventoryGroup._id] = item.inventories;
          });
        this.aggregated["instantProducts"] = res.appointment.products.filter(
          (eachProduct) => eachProduct?.productCategoryData
        );
      }
      this.slotService.sizeInCartItems = this.aggregated;
    } else {
      this.response_cart = [];
    }
  }
  fetchCompleteBusinessUnit(bUnit) {
    if (
      !sessionStorage.getItem("currentBusinessUnit") ||
      JSON.parse(sessionStorage.getItem("currentBusinessUnit"))._id !==
        bUnit._id
    ) {
      let unitId =
        bUnit?._id ||
        sessionStorage.getItem("businessUnit") ||
        (sessionStorage.getItem("currentBusinessUnit") &&
          JSON.parse(sessionStorage.getItem("currentBusinessUnit"))._id);
      this.valuChainUserService.getCurrentBusinessUnitData(unitId).subscribe(
        (res) => {
          this.slotService.removePaymentModesAndTerms(res);
          sessionStorage.setItem("currentBusinessUnit", JSON.stringify(res));
          this.slotService.currentBusinessUnit = res;
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
  getProductPrice(inventoryGroup, isGroup?) {
    if (
      !this.updateAppointmentProductsService?.bussinessUnitSettings &&
      sessionStorage.getItem("currentBusinessUnit")
    ) {
      this.updateAppointmentProductsService.bussinessUnitSettings = JSON.parse(
        sessionStorage.getItem("currentBusinessUnit")
      ).settings;
    }
    let price =
      !isGroup &&
      this.updateAppointmentProductsService?.bussinessUnitSettings?.whiteshop
        ?.orderPriceField &&
      this.updateAppointmentProductsService?.bussinessUnitSettings?.whiteshop
        ?.orderPriceField?.length
        ? inventoryGroup.price[
            this.updateAppointmentProductsService.bussinessUnitSettings
              .whiteshop.orderPriceField
          ]?.value
          ? inventoryGroup.price[
              this.updateAppointmentProductsService.bussinessUnitSettings
                .whiteshop.orderPriceField
            ].value
          : inventoryGroup.price?.MRP?.value
        : inventoryGroup.price?.MRP?.value;
    return price;
  }

  openMediaStreamDialog() {
    if (
      !this.mediaStreamPermissionsComponentRef ||
      this.mediaStreamPermissionsComponentRef?.getState() !==
        MatDialogState.OPEN
    ) {
      this.mediaStreamPermissionsComponentRef = this.dialog.open(
        MediaStreamPermissionsComponent,
        {
          width: this.isMobileDevice() ? "100vw" : "30vw",
          minWidth: this.isMobileDevice() ? "100vw" : "30vw",
          height: this.isMobileDevice() ? "calc(100vh - 3rem)" : "100vh",
          minHeight: this.isMobileDevice() ? "calc(100vh - 3rem)" : "100vh",
          position: {
            left: this.isMobileDevice() ? "0vw" : "35vw",
            top: "0vh",
          },
          panelClass: "link-copy-dialog",
          disableClose: true,
          closeOnNavigation: true,
        }
      );
    }
  }
}
